import { render, staticRenderFns } from "./transferEdit.vue?vue&type=template&id=34b4cd76&scoped=true"
import script from "./transferEdit.vue?vue&type=script&lang=js"
export * from "./transferEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4cd76",
  null
  
)

export default component.exports